import React from 'react';
import { useThemeContext, WizardContext } from '../../../../context';
import { SelectList } from '../../SelectList';
import { WizardButton } from '../../../Shared/Wizard';
import { StyledLabel, WizardActions } from '../../../Shared/Styled';
import { SelectItem } from '../../../../types';
import { SearchBox } from '../../Search';

export interface NamedVersionSelectionProps {
  items: SelectItem[];
  selected?: string;
  onSearch: (input: string) => void;
  onClear: () => void;
  onChange: (input: string) => void;
}

export function NamedVersionSelection({
  items,
  selected,
  onSearch,
  onClear,
  onChange,
}: NamedVersionSelectionProps) {
  const theme = useThemeContext();
  return (
    <WizardContext.Consumer>
      {({ goto }) => (
        <div
          id='NamedVersionSelection'
          style={{
            display: 'inline-flex',
            width: '100%',
            flexDirection: 'column',
          }}
        >
          <StyledLabel style={{ marginTop: '9px' }} themeStr={theme}>
            <span>Select a Named Version</span>
          </StyledLabel>
          <SearchBox
            placeholder={'Enter filter criteria'}
            onSearch={onSearch}
            onClear={onClear}
            onChange={onChange}
            inputValue={undefined}
            isFilterBox={true}
            theme={theme}
          />
          <SelectList
            items={items}
            selected={selected}
            selectedProperty='value'
          />
          <WizardActions>
            <WizardButton
              direction='back'
              label='iModel'
              onClick={() => goto('choose-imodel')}
              theme={theme}
            />
            <WizardButton
              direction='forward'
              label='Default View'
              disabled={items.length === 0 || !selected}
              onClick={() => goto('choose-default-view')}
              theme={theme}
            />
          </WizardActions>
        </div>
      )}
    </WizardContext.Consumer>
  );
}
